import React, { FC, useMemo, useState } from 'react'
import { OrderDetailCardItem, styled } from '~/app/components'
import { ConvertedOrder } from '~/app/components/order-converter/getCartOrderConverter'
import ShowMore from '~/app/components/order-list/common/OrderListShowMore'

interface OrderDetailListProps {
  /** 상품 목록 */
  orderDetails?: ConvertedOrder[]
  /** 버튼 클릭 이벤트 */
  onButtonClick: (id: string, data?: any) => void
  /** 버튼 노출 이벤트 */
  onButtonImpressed: (id: string, data?: any) => void
  /** 상품 클릭 이벤트 */
  onProductClick?: (id: string, url: string, deeplink?: string) => void
  /** 더보기 토글 이벤트 */
  onShowMoreToggle?: (isShowMore: boolean) => void
  /** 더보기 노출 이벤트 */
  onShowMoreImpressed?: () => void
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.unit.PC_WIDTH}px) {
    padding-top: 1rem;
    flex-direction: row;
    flex-flow: wrap;
  }
`

const OrderListShowMore = styled(ShowMore)`
  border-top: 0.1rem solid ${({ theme }) => theme.color.gray200};
  margin: 0 2rem;
  width: auto;

  @media (min-width: ${({ theme }) => theme.unit.PC_WIDTH}px) {
    width: 100%;
    border-top: none;
  }
`

const DEFAULT_CARD_ITEM_COUNT = 6 // 예약상세 기본 출력 아이템 개수

const OrderDetailList: FC<OrderDetailListProps> = ({
  orderDetails,
  onButtonClick,
  onButtonImpressed,
  onProductClick,
  onShowMoreToggle,
  onShowMoreImpressed,
}) => {
  const [isShowMore, setIsShowMore] = useState(false)

  const handleShowMoreClick = () => {
    setIsShowMore(v => !v)
    onShowMoreToggle?.(isShowMore)
  }

  const cardItems = orderDetails?.map((prop, index) => (
    <OrderDetailCardItem
      key={index}
      isFirstItem={index === 0}
      onButtonClick={onButtonClick}
      onButtonImpressed={onButtonImpressed}
      onProductClick={onProductClick}
      {...prop}
    />
  ))

  const cardItemsShown = useMemo(
    () => (cardItems ?? []).slice(0, isShowMore ? undefined : DEFAULT_CARD_ITEM_COUNT),
    [cardItems, isShowMore]
  )

  return (
    <Container>
      {cardItemsShown}
      {(cardItems?.length ?? 0) > DEFAULT_CARD_ITEM_COUNT && (
        <OrderListShowMore
          isShowMore={isShowMore}
          onClick={handleShowMoreClick}
          onImpressed={onShowMoreImpressed}
          remainingCount={cardItems!.length - DEFAULT_CARD_ITEM_COUNT}
        />
      )}
    </Container>
  )
}

export default OrderDetailList
